<template>
  <div>
    <sticky class="page-header sticky-page-header">
      <slot v-for="p in periods" name="filter-button">
        <a @click="changePeriod(p)" slot="left" :disabled="loading" class="button is-white"
           :class="{'is-active': period === p}">
          <span>{{p.name}}</span>
        </a>
      </slot>
    </sticky>
    <div class="columns">
      <div class="column is-one-third">
        <h3 class="title has-text-centered is-3">Répartion des connexions par navigateur</h3>
        <canvas id="browser-pie"></canvas>
      </div>
      <div class="column is-one-third">
        <h3 class="title has-text-centered is-3">Répartion des connexions par plateforme</h3>
        <canvas id="platform-pie"></canvas>
      </div>
      <div class="column is-one-third">
        <h3 class="title has-text-centered is-3">Répartion des connexions par ville</h3>
        <canvas id="users-pie"></canvas>
      </div>
    </div>
    <div class="columns">
      <div class="column is-half">
        <h3 class="title has-text-centered is-3">Evolution du nombre de connexions</h3>
        <canvas id="log-line"></canvas>
      </div>
      <div class="column is-2">
        <label class="label">Echelle de temps</label>
        <div class="control">
          <div class="select">
            <select v-model="userLogsScale">
              <option v-for="s in scalesList" :value="s.value">{{s.label}}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="column" v-if="userStats && mostActiveUsers && mostActiveUsers.length > 0">
        <div class="tile is-parent">
          <div class="tile is-child notification is-info">
            <div class="heading">Utilisateurs les plus actifs</div>
            <div class="title"><b>1er: </b>{{mostActiveUsers[0].name}}</div>
            <div v-if="mostActiveUsers.length > 1" class="title"><b>2e: </b>{{mostActiveUsers[1].name}}</div>
            <div v-if="mostActiveUsers.length > 2" class="title"><b>3e: </b>{{mostActiveUsers[2].name}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column is-half">
        <h3 class="title has-text-centered is-3">Evolution du nombre d'options</h3>
        <canvas id="options-line"></canvas>
      </div>
      <div class="column is-2">
        <label class="label">Echelle de temps</label>
        <div class="control">
          <div class="select">
            <select v-model="optionScale">
              <option v-for="s in scalesList" :value="s.value">{{s.label}}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="column" v-if="optionStats && bestSellers && bestSellers.length > 0">
        <div class="tile is-parent">
          <div class="tile is-child notification is-info">
            <div class="heading">Vendeurs les plus actifs</div>
            <div class="title"><b>1er: </b>{{bestSellers[0].name}}</div>
            <div v-if="bestSellers.length > 1" class="title"><b>2e: </b>{{bestSellers[1].name}}</div>
            <div v-if="bestSellers.length > 2" class="title"><b>3e: </b>{{bestSellers[2].name}}</div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  // import Pie from '../charts/pie-chart'
  import { orderBy } from 'lodash'
  import moment from 'moment'
  import Chart from 'chart.js'
  import randomColor from 'randomcolor'
  import hexToRgba from 'hex-rgba'

  const SCALES = Object.freeze({
    DAY: {value: 'DD/MM', label: 'Jour'},
    MONTH: {value: 'MMM YYYY', label: 'Mois'},
    YEAR: {value: 'YYYY', label: 'Année'},
    HOUR: {value: 'DD/MM HH', label: 'Heure'}
  })

  export default {
    name: 'StatsVue',
    data () {
      return {
        SCALES: SCALES,
        periods: [],
        period: null,
        optionStats: [],
        userLogsScale: SCALES.DAY.value,
        optionScale: SCALES.DAY.value,
        displayLogLines: true,
        userStats: [],
        charts: {},
        logsChart: null,
        optionsChart: null,
        browserChart: null,
        loadingUserStats: false,
        loadingOptionStats: false
      }
    },
    computed: {
      loading () {
        return this.loadingOptionStats && this.loadingUserStats
      },
      scalesList () {
        return Object.values(this.SCALES)
      },
      bestSellers () {
        let tmp = {}
        this.optionStats.forEach(x => {
          let name = x.seller_name
          if (!(name in tmp)) {
            tmp[name] = {
              name: name,
              count: 0
            }
          }
          tmp[name]['count'] += 1
        })

        return orderBy(Object.values(tmp), 'count', 'desc')
      },
      mostActiveUsers () {
        let tmp = {}
        this.userStats.forEach(x => {
          let name = x.user_name
          if (!(name in tmp)) {
            tmp[name] = {
              name: name,
              count: 0
            }
          }
          tmp[name]['count'] += 1
        })

        return orderBy(Object.values(tmp), 'count', 'desc')
      }
    },
    watch: {
      userLogsScale (scale) {
        let data = this.computedStatsEvolution(this.userStats, 'date', {
          chartLabel: 'Connexions',
          scale: scale
        })
        this.drawLine('log-line', data)
      },
      optionScale (scale) {
        let data = this.computedStatsEvolution(this.optionStats, 'start_date', {
          chartLabel: 'Options',
          scale: scale
        })
        this.drawLine('options-line', data)
      }
    },
    methods: {
      changePeriod (period) {
        this.period = period
        this.loadData()
      },
      initPeriods () {
        let now = moment()
        this.periods.push({
          name: 'Aujourd\'hui',
          start: now.startOf('day').format('DD/MM/YYYY HH:mm'),
          end: now.endOf('day').format('DD/MM/YYYY HH:mm')
        })
        let yesterday = moment().subtract(1, 'day')
        this.periods.push({
          name: 'Hier',
          start: yesterday.startOf('day').format('DD/MM/YYYY HH:mm'),
          end: yesterday.endOf('day').format('DD/MM/YYYY HH:mm')
        })
        let oneWeek = moment().subtract(7, 'day')
        this.periods.push({
          name: '1 semaine',
          start: oneWeek.startOf('day').format('DD/MM/YYYY HH:mm'),
          end: now.endOf('day').format('DD/MM/YYYY HH:mm')
        })
        let twoWeeks = moment().subtract(14, 'day')
        this.periods.push({
          name: '2 semaines',
          start: twoWeeks.startOf('day').format('DD/MM/YYYY HH:mm'),
          end: now.endOf('day').format('DD/MM/YYYY HH:mm')
        })
        let oneMonth = moment().subtract(1, 'month')
        this.periods.push({
          name: '1 mois',
          start: oneMonth.startOf('day').format('DD/MM/YYYY HH:mm'),
          end: now.endOf('day').format('DD/MM/YYYY HH:mm')
        })
        let twoMonth = moment().subtract(2, 'month')
        this.periods.push({
          name: '2 mois',
          start: twoMonth.startOf('day').format('DD/MM/YYYY HH:mm'),
          end: now.endOf('day').format('DD/MM/YYYY HH:mm')
        })
        let oneYear = moment().subtract(1, 'year')
        this.periods.push({
          name: '1 An',
          start: oneYear.startOf('day').format('DD/MM/YYYY HH:mm'),
          end: now.endOf('day').format('DD/MM/YYYY HH:mm')
        })
        let currentYear = moment().startOf('year')
        this.periods.push({
          name: 'Année en cours',
          start: currentYear.startOf('day').format('DD/MM/YYYY HH:mm'),
          end: now.endOf('day').format('DD/MM/YYYY HH:mm')
        })
      },
      loadData () {
        this.loadUserStats()
        this.loadOptionStats()
      },
      drawLine (canvasId, data, params = null) {
        let ctx = document.getElementById(canvasId).getContext('2d')

        let defaultOptions = {
          responsive: true,
          legend: {
            position: 'bottom'
          },
          scales: {
            yAxes: [{
              ticks: {
                min: 0,
                beginAtZero: true
                // stepSize: 1
              }
            }]
          }
        }
        let options
        if (params) {
          options = Object.assign({}, defaultOptions, params)
        } else {
          options = Object.assign({}, defaultOptions)
        }

        if (this.charts[canvasId]) {
          this.charts[canvasId].destroy()
        }

        let chart = new Chart(ctx, {
          type: 'line',
          data,
          options
        })

        this.charts[canvasId] = chart
        return chart
      },
      drawPie (canvasId, data, params = null) {
        let ctx = document.getElementById(canvasId).getContext('2d')
        // https://codepen.io/k3no/pen/WGmVBr?editors=0010
        let defaultOptions = {
          responsive: true,
          legend: {
            position: 'bottom'
          }
        }
        let options
        if (params) {
          options = Object.assign({}, defaultOptions, params)
        } else {
          options = Object.assign({}, defaultOptions)
        }

        if (this.charts[canvasId]) {
          this.charts[canvasId].destroy()
        }

        let chart = new Chart(ctx, {
          type: 'pie',
          data,
          options
        })
        this.charts[canvasId] = chart
        return chart
      },
      computedStatsEvolution (rawStats, key, {chartLabel, scale}) {
        if (!scale) {
          scale = SCALES.DAY.value
        }
        let labels = []
        let color = randomColor({
          hue: 'blue'
        })
        let datasets = {
          label: chartLabel,
          borderColor: hexToRgba(color, 70),
          backgroundColor: hexToRgba(color, 10),
          borderWidth: 2,
          fill: false,
          data: []
        }
        let tmpData = {}

        rawStats.forEach(sample => {
          let date = moment(sample[key])
          let label = date.format(scale)
          if (!(label in tmpData)) {
            tmpData[label] = {
              label: label,
              date: sample[key],
              count: 0
            }
          }
          tmpData[label].count += 1
        })

        tmpData = Object.values(tmpData)
        tmpData.sort(function (a, b) {
          return new Date(b.date) - new Date(a.date)
        })
        tmpData = tmpData.reverse()
        tmpData.forEach(set => {
          labels.push(moment(set.date).format('DD/MM/YYYY'))
          datasets.data.push(set.count)
        })

        return {
          labels,
          datasets: [
            datasets
          ]
        }
      },
      computedStatsRepartion (rawStats, key, chartLabel, limit = null) {
        let labels = []
        let datasets = {
          label: chartLabel,
          backgroundColor: [],
          data: []
        }
        let tmpData = {}

        rawStats.forEach(sample => {
          if (key in sample && sample[key] !== null) {
            let label = sample[key]

            if (!(label in tmpData)) {
              tmpData[label] = {
                label: label,
                count: 0
              }
            }
            tmpData[label].count += 1
          }
        })
        let values = Object.values(tmpData)

        values = orderBy(values, 'count', 'desc')

        if (limit && limit < values.length) {
          values = values.slice(0, limit)
        }

        values.forEach(x => {
          datasets.backgroundColor.push(randomColor({
            hue: 'blue'
          }))
          datasets.data.push(x.count)
          labels.push(x.label)
        })

        return {
          labels,
          datasets: [
            datasets
          ]
        }
      },
      loadOptionStats () {
        let query = {
          'start': this.period.start,
          'end': this.period.end
        }
        this.loadingOptionStats = false
        this.$api.debugService.getOptionStats(query)
          .then(res => {
            this.optionStats = res.data
            this.loadingOptionStats = true
            let data = this.computedStatsEvolution(res.data, 'start_date', {chartLabel: 'Options'})
            this.drawLine('options-line', data)
          })
      },
      loadUserStats () {
        let query = {
          'start': this.period.start,
          'end': this.period.end
        }
        this.loadingUserStats = true
        this.$api.debugService.getUserStats(query)
          .then(res => {
            this.userStats = res.data
            this.loadingUserStats = false
            let data = this.computedStatsRepartion(res.data, 'browser', 'Navigateur')
            this.drawPie('browser-pie', data)
            let data2 = this.computedStatsEvolution(res.data, 'date', {chartLabel: 'Connexions'})
            this.drawLine('log-line', data2)
            let data3 = this.computedStatsRepartion(res.data, 'platform', 'Plateformes')
            this.drawPie('platform-pie', data3)
            let data4 = this.computedStatsRepartion(res.data, 'city', 'Ville', 5)
            this.drawPie('users-pie', data4)
          })
      }
    },
    mounted () {
      this.loadData()
    },
    created () {
      this.initPeriods()
      this.period = this.periods[this.periods.length - 1]
    }
  }
</script>

<style>
  canvas {
    height: 300px;
  }

</style>



// WEBPACK FOOTER //
// src/components/debug/UserStatsVue.vue